import {
  getSolutionHotKeyWords,
  getSolutionByKeyWord,
  getSolutions,
  getSolutionsDetail,
  getRelatedSolutions,
  collect,
  getSolutionsDetailAndUserId
} from '@/api/solutions/solution'

const state = {
  keyWords: [], // 存储热词
  solutions: []
}

const actions = {
  /* 查询热词 */
  SOLUTIONS_GET_KEYWORD ({ commit }) {
    // 固定8个
    let size = 8
    getSolutionHotKeyWords({ num: size }).then(result => {
      if (result && result.status === 200 && result.data && result.data.code === 200 && result.data.data) {
        commit('SOLUTIONS_SET_KEYWORD', result.data.data.list)
      }
    })
  },
  /* 根据关键字查询方案列表 */
  SOLUTIONS_GET_LIST_BY_KEYWORD ({ state }, params) {
    return getSolutionByKeyWord(params)
  },
  // 方案列表查询接口
  SOLUTIONS_GET_LIST ({ commit }, params) {
    return getSolutions(params)
  },
   // 方案收藏接口
   SOLUTIONS_POST_COLLECT ({ commit }, params) {
    return collect(params)
  },
  // 根据方案id查询方案详情
  SOLUTIONS_GET_DETAIL ({ commit }, id) {
    return getSolutionsDetail(id)
  },
  // 根据方案id和用户id查询方案详情
  SOLUTIONS_GET_DETAILANDUSERID ({ commit }, id) {
    return getSolutionsDetailAndUserId(id)
  },
  // 根据方案id查询相关方案 最多5条
  SOLUTIONS_GET_RELATED_SOL ({ commit }, id) {
    let params = {
      limit: 5
    }
    return getRelatedSolutions(id, params)
  }
}

const getters = {

}

const mutations = {
  /* 设置热词 */
  SOLUTIONS_SET_KEYWORD (state, data) {
    state.keyWords = data
  },
  /* 设置方案列表数据 */
  SOLUTIONS_SET_LIST (state, data) {
    if (data.type && data.type === 'append') {
      Object.assign(state.solutions, data.list)
    } else {
      state.solutions = data.list
    }
  }
}

export default {
  state,
  actions,
  getters,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/solutions/solution.js